<template>
<div class="row">
        <div class="col-12">
            <input
            ref="input"
            type="file"
            name="image"
            accept="image/*"
            
            @change="setImage"
            />
            <input type="hidden" name="avatar" class="noShow" :value="cropImg">
        </div>

        <div class="col-12">
        <div class="row">
            <div class="col-12 col-md-4">
                <div class="img-cropper">
                    <!-- <vue-cropper
                        ref="cropper"
                        :aspect-ratio="1 / 1"
                        :src="imgSrc"
                        preview=".preview"
                    /> -->
                </div>


                <div class="actions">
                    <div class="row">
                        <div class="col-4">
                            <a class="" href="#" role="button" @click.prevent="showFileChooser">{{__("forms.editAvatar.loadImage")}}</a>
                        </div>
                        <div class="col-4">
                            <a class="" href="#" role="button" @click.prevent="cropImage">{{__("forms.editAvatar.cutImage")}}</a>
                        </div>
                        <div class="col-4">
                            <a class=""    href="#" role="button" @click.prevent="reset">{{__("forms.editAvatar.resetImage")}}</a>
                        </div>
                    </div>
                    <hr/>
                    <h6 class="pb-5 my-auto">{{__("forms.editAvatar.extraFunctions")}}</h6>
                    <div class="row">
                        <div class="col-3">
                            <a class="" href="#" role="button" @click.prevent="zoom(0.2)"><i class="fal fa-plus-circle"></i></a>
                        </div>
                        <div class="col-3">
                            <a class=""  href="#" role="button" @click.prevent="zoom(-0.2)"><i class="fal fa-minus-circle"></i></a>
                        </div>
                        <div class="col-3">
                            <a class="" href="#" role="button" @click.prevent="move(-10, 0)"><i class="fal fa-chevron-circle-left"></i></a>
                        </div>
                        <div class="col-3">
                            <a class="" href="#" role="button" @click.prevent="move(10, 0)"><i class="fal fa-chevron-circle-right"></i></a>
                        </div>
                        <div class="col-3">
                            <a class="" href="#" role="button" @click.prevent="move(0, -10)"><i class="fal fa-chevron-circle-up"></i></a>
                        </div>
                        <div class="col-3">
                            <a class="" href="#" role="button" @click.prevent="move(0, 10)" ><i class="far fa-chevron-circle-down"></i></a>
                        </div>
                        <div class="col-3">
                            <a class="" href="#" role="button" @click.prevent="rotate(90)"><i class="fal fa-undo fa-flip-horizontal"></i></a>
                        </div>
                        <div class="col-3">
                            <a class="" href="#" role="button" @click.prevent="rotate(-90)"><i class="fal fa-undo"></i></a>
                        </div>
                        <div class="col-3">
                            <a class="" ref="flipX" href="#" role="button" @click.prevent="flipX"><i class="fal fa-arrows-h"></i></a>
                        </div>
                        <div class="col-3">
                            <a class="" ref="flipY" href="#" role="button" @click.prevent="flipY"> <i class="fal fa-arrows-v"></i></a>
                        </div>
                    </div>
                    <!-- <div class="row">
                        <div class="col-4">
                            <a class="" href="#" role="button" @click.prevent="zoom(0.2)">{{__("forms.editAvatar.zoomIn")}}</a>
                        </div>
                        <div class="col-4">
                            <a class=""  href="#" role="button" @click.prevent="zoom(-0.2)">{{__("forms.editAvatar.zoomOut")}}</a>
                        </div>
                        <div class="col-4">
                            <a class="" href="#" role="button" @click.prevent="move(-10, 0)">{{__("forms.editAvatar.moveLeft")}}</a>
                        </div>
                        <div class="col-4">
                            <a class="" href="#" role="button" @click.prevent="move(10, 0)">{{__("forms.editAvatar.moveRight")}}</a>
                        </div>
                        <div class="col-4">
                            <a class="" href="#" role="button" @click.prevent="move(0, -10)">{{__("forms.editAvatar.moveUp")}}</a>
                        </div>
                        <div class="col-4">
                            <a class="" href="#" role="button" @click.prevent="move(0, 10)" >{{__("forms.editAvatar.moveDown")}}</a>
                        </div>
                        <div class="col-4">
                            <a class="" href="#" role="button" @click.prevent="rotate(90)">{{__("forms.editAvatar.rotatePlus90")}}</a>
                        </div>
                        <div class="col-4">
                            <a class="" href="#" role="button" @click.prevent="rotate(-90)">{{__("forms.editAvatar.rotateMinus90")}}</a>
                        </div>
                        <div class="col-4">
                            <a class="" ref="flipX" href="#" role="button" @click.prevent="flipX">{{__("forms.editAvatar.flipX")}}</a>
                        </div>
                        <div class="col-4">
                            <a class="" ref="flipY" href="#" role="button" @click.prevent="flipY"> {{__("forms.editAvatar.flipY")}}</a>
                        </div>
                    </div> -->
                </div>
            </div>
            <div class="col-12 col-md-4">
                <p>{{__("forms.editAvatar.preview")}}</p>
                <div class="preview"></div>
            </div>
            <div class="col-12 col-md-4">
                <p>{{__("forms.editAvatar.croppedImage")}}</p>
                <div class="cropped-image">
                    <img
                        v-if="cropImg"
                        :src="cropImg"
                        alt="Cropped Image"
                    />
                    <div v-else class="crop-placeholder" />
                </div>
            </div>
        </div>
        </div>
        
        <div class="content-photo d-none">
            <section class="mr-lg-5 cropper-area">
                <div class="img-cropper">
                    <vue-cropper
                        ref="cropper"
                        :aspect-ratio="1 / 1"
                        :src="imgSrc"
                        preview=".preview"
                    />
                </div>


                <div class="actions">
                    <div class="row">
                        <a class="col-3" href="#" role="button" @click.prevent="showFileChooser">{{__("forms.editAvatar.loadImage")}}</a>
                        <a class="col-3"href="#" role="button" @click.prevent="cropImage">{{__("forms.editAvatar.cutImage")}}</a>
                        <a class="col-3"    href="#" role="button" @click.prevent="reset">{{__("forms.editAvatar.resetImage")}}</a>
                    </div>
                    <hr/>
                    <h6 class="pb-5 my-auto">{{__("forms.editAvatar.extraFunctions")}}</h6>
                    <div class="row">
                        <a class="col-3" href="#" role="button" @click.prevent="zoom(0.2)">{{__("forms.editAvatar.zoomIn")}}</a>
                        <a class="col-3"  href="#" role="button" @click.prevent="zoom(-0.2)">{{__("forms.editAvatar.zoomOut")}}</a>
                        <a class="col-3" href="#" role="button" @click.prevent="move(-10, 0)">{{__("forms.editAvatar.moveLeft")}}</a>
                        <a class="col-3" href="#" role="button" @click.prevent="move(10, 0)">{{__("forms.editAvatar.moveRight")}}</a>
                        <a class="col-3" href="#" role="button" @click.prevent="move(0, -10)">{{__("forms.editAvatar.moveUp")}}</a>
                        <a class="col-3" href="#" role="button" @click.prevent="move(0, 10)" >{{__("forms.editAvatar.moveDown")}}</a>
                        <a  class="col-3" href="#" role="button" @click.prevent="rotate(90)">{{__("forms.editAvatar.rotatePlus90")}}</a>
                        <a  class="col-3" href="#" role="button" @click.prevent="rotate(-90)">{{__("forms.editAvatar.rotateMinus90")}}</a>
                        <a  class="col-3" ref="flipX" href="#" role="button" @click.prevent="flipX">{{__("forms.editAvatar.flipX")}}</a>
                        <a  class="col-3" ref="flipY" href="#" role="button" @click.prevent="flipY"> {{__("forms.editAvatar.flipY")}}</a>
                    </div>
                </div>

            </section>
            <section class="preview-area">
                <p>{{__("forms.editAvatar.preview")}}</p>
                <div class="preview" />
                <p>{{__("forms.editAvatar.croppedImage")}}</p>
                <div class="cropped-image">
                    <img
                        v-if="cropImg"
                        :src="cropImg"
                        alt="Cropped Image"
                    />
                    <div v-else class="crop-placeholder" />
                </div>
            </section>
        </div>
    </div>
    <!-- <div>
        <input
            ref="input"
            type="file"
            name="image"
            accept="image/*"
            @change="setImage"
        />
        <input type="hidden" name="avatar" class="noShow" :value="cropImg">
        <div class="content-photo">
            <section class="mr-lg-5 cropper-area">
                <div class="img-cropper">
                    <vue-cropper
                        ref="cropper"
                        :aspect-ratio="1 / 1"
                        :src="imgSrc"
                        preview=".preview"
                    />
                </div>


                <div class="actions">
                    <div class="row">
                        <a class="col-3" href="#" role="button" @click.prevent="showFileChooser">{{__("forms.editAvatar.loadImage")}}</a>
                        <a class="col-3"href="#" role="button" @click.prevent="cropImage">{{__("forms.editAvatar.cutImage")}}</a>
                        <a class="col-3"    href="#" role="button" @click.prevent="reset">{{__("forms.editAvatar.resetImage")}}</a>
                    </div>
                    <hr/>
                    <h6 class="pb-5 my-auto">{{__("forms.editAvatar.extraFunctions")}}</h6>
                    <div class="row">
                        <a class="col-3" href="#" role="button" @click.prevent="zoom(0.2)">{{__("forms.editAvatar.zoomIn")}}</a>
                        <a class="col-3"  href="#" role="button" @click.prevent="zoom(-0.2)">{{__("forms.editAvatar.zoomOut")}}</a>
                        <a class="col-3" href="#" role="button" @click.prevent="move(-10, 0)">{{__("forms.editAvatar.moveLeft")}}</a>
                        <a class="col-3" href="#" role="button" @click.prevent="move(10, 0)">{{__("forms.editAvatar.moveRight")}}</a>
                        <a class="col-3" href="#" role="button" @click.prevent="move(0, -10)">{{__("forms.editAvatar.moveUp")}}</a>
                        <a class="col-3" href="#" role="button" @click.prevent="move(0, 10)" >{{__("forms.editAvatar.moveDown")}}</a>
                        <a  class="col-3" href="#" role="button" @click.prevent="rotate(90)">{{__("forms.editAvatar.rotatePlus90")}}</a>
                        <a  class="col-3" href="#" role="button" @click.prevent="rotate(-90)">{{__("forms.editAvatar.rotateMinus90")}}</a>
                        <a  class="col-3" ref="flipX" href="#" role="button" @click.prevent="flipX">{{__("forms.editAvatar.flipX")}}</a>
                        <a  class="col-3" ref="flipY" href="#" role="button" @click.prevent="flipY"> {{__("forms.editAvatar.flipY")}}</a>
                    </div>
                </div>

            </section>
            <section class="preview-area">
                <p>{{__("forms.editAvatar.preview")}}</p>
                <div class="preview" />
                <p>{{__("forms.editAvatar.croppedImage")}}</p>
                <div class="cropped-image">
                    <img
                        v-if="cropImg"
                        :src="cropImg"
                        alt="Cropped Image"
                    />
                    <div v-else class="crop-placeholder" />
                </div>
            </section>
        </div>
    </div> -->
</template>

<script>

import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
export default {
    components: {
        VueCropper,
    },
    data() {
        return {
            imgSrc: '',
            cropImg: '',
            data: null,
        };
    },
    props:{
        user_avatar:{
            type: String,
            required: false
        }
    },
    mounted(){
        //console.log(this.user_avatar);
        //this.imgSrc = this.user_avatar;
    },
    methods: {

        cropImage() {
            // get image data for post processing, e.g. upload or setting image src
            this.cropImg = this.$refs.cropper.getCroppedCanvas({
                maxHeight : 256,
                maxWidth : 256,
                minWidth : 256,
                minHeight : 256
            }).toDataURL();


        },
        flipX() {
            const dom = this.$refs.flipX;
            let scale = dom.getAttribute('data-scale');
            scale = scale ? -scale : -1;
            this.$refs.cropper.scaleX(scale);
            dom.setAttribute('data-scale', scale);
        },
        flipY() {
            const dom = this.$refs.flipY;
            let scale = dom.getAttribute('data-scale');
            scale = scale ? -scale : -1;
            this.$refs.cropper.scaleY(scale);
            dom.setAttribute('data-scale', scale);
        },

        move(offsetX, offsetY) {
            this.$refs.cropper.move(offsetX, offsetY);
        },
        reset() {
            this.$refs.cropper.reset();
        },
        rotate(deg) {
            this.$refs.cropper.rotate(deg);
        },
        setCropBoxData() {
            if (!this.data) return;
            this.$refs.cropper.setCropBoxData(JSON.parse(this.data));
        },
        setData() {
            if (!this.data) return;
            this.$refs.cropper.setData(JSON.parse(this.data));
        },
        setImage(e) {
            const file = e.target.files[0];
            if (file.type.indexOf('image/') === -1) {
                alert('Please select an image file');
                return;
            }
            if (typeof FileReader === 'function') {
                const reader = new FileReader();
                reader.onload = (event) => {
                    this.imgSrc = event.target.result;
                    // rebuild cropperjs with the updated source
                    this.$refs.cropper.replace(event.target.result);
                };
                reader.readAsDataURL(file);
            } else {
                alert('Sorry, FileReader API not supported');
            }
        },
        showFileChooser() {
            this.$refs.input.click();
        },
        zoom(percent) {
            this.$refs.cropper.relativeZoom(percent);
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

.noShow input {
    display: none;
}
.content-photo {
    display: flex;
    justify-content: space-between;
}
.cropper-area {
    width: 614px;
}
.actions {
    margin-top: 1rem;
}
.actions a {
    display: block;
    padding: 5px 15px;
    background: #0062CC;
    color: white;
    text-decoration: none;
    border-radius: 3px;
    /* margin-right: 1rem; */
    margin-bottom: 1rem;
    text-align: center;
}

.preview-area {
    width: 307px;
}
.preview-area p {
    font-size: 1.25rem;
    margin: 0;
    margin-bottom: 1rem;
}
.preview-area p:last-of-type {
    margin-top: 1rem;
}
.preview {
    width: 100%;
    height: calc(372px * (16/16));
    overflow: hidden;
}
.crop-placeholder {
    width: 100%;
    height: 200px;
    background: #ccc;
}
.cropped-image img {
    max-width: 100%;
}
</style>
